import { engagementApiSuppressionLists } from "@dashboardApi/apis/engagementApiSuppressionLists";
import { engagementSegments } from "@dashboardApi/apis/engagementSegments";

import type { AllRouteEndpoints } from "../routeTypes";

export const engagementSegmentsMarkAsArchivedCacheKeys: AllRouteEndpoints[] = [
  engagementSegments,
  engagementApiSuppressionLists,
];
